import { createFileRoute } from '@tanstack/react-router'

import { RequestPasswordReset } from '@/containers/ResetPassword'

export const Route = createFileRoute(
  '/_unauthenticated/request-password-reset'
)({
  component: RequestPasswordReset,
})
